<template>
  <NewTooltip placement="top" :auto-ellipsis="true" :arrow="true" class="title-tooltip">
    <div class="title">
      <span class="title-text">
        {{ title }}
      </span>
      <VideoAiTag v-if="isAiVideo" />
    </div>
    <template #content>
      {{ title }}
    </template>
  </NewTooltip>
</template>

<script setup lang="ts">
import { NewTooltip } from '@/components/common'
import VideoAiTag from '@/components/base/video-component-tags/VideoAiTag.vue'

withDefaults(
  defineProps<{
    title?: string
    isAiVideo?: boolean
  }>(),
  {
    title: ''
  }
)
</script>

<style scoped lang="scss">
.title-tooltip {
  min-width: 0;
  overflow: hidden;

  :deep(.tooltip-container) {
    display: block;
    width: 100%;
    min-width: 0;
    overflow: hidden;
  }
}

.title {
  font-weight: 700;
  font-size: 14px;
  color: $bodyText;
  margin: 0 0 4px 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: flex;
  align-items: space-between;
  gap: 4px;
}

.title-text {
  @include textTruncate(1);
}
</style>

